<template>
  <div id="headbar" class="container">
    <div class="topTimer">
      <span>{{ timerCount }}</span> 초 후 새로고침
      <span class="timerUpdate">update</span>
      <span>{{ lastUpdateDate }}</span>
    </div>
  </div>
</template>

<script>
const timeDefault = '60'
export default {
  name: 'headbar',
  data () {
    return {
      timerCount: timeDefault,
      lastUpdateDate: ''
    }
  },
  methods: {
    countSeconds () {
      if (this.timerCount >= 0) {
        setTimeout(() => {
          this.timerCount -= 1
          this.countSeconds()
        }, 1000)
      } else {
        this.fetchData()
      }
    },
    fetchData () {
      this.timerCount = timeDefault
      this.countSeconds()
      this.$root.$refs.M.fetchData()
    }
  },
  created () {
    this.$root.$refs.H = this
    this.countSeconds()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header.vue